import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {isoCountries} from '../../../constants';
import InputField from '../../../components/new-ui/input_field';
import * as tracking from '../../../tracking';
import DropdownV2 from '../../../forecast-app/shared/components/dropdowns/dropdown';

export const EU_COUNTRIES_CODES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

class DetailsSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			vat_prefix: props.country || null,
			loading: false,
			apiLoaded: false,
			editCardEnabled: false,
			showEmailValidationError: false,
			emailValidationErrorMessage: '',
		};
	}

	componentDidMount() {
		tracking.trackPage('trial-signup-company-details');
	}

	handleFieldChange(property, e) {
		this.props.handleFieldChange(property, e);
	}

	handleChangeCountry(selection) {
		if (EU_COUNTRIES_CODES.includes(selection.value)) {
			// This is to handle that Greece is the only one not using the same VAT country code as ISO country code
			this.setState({vat_prefix: selection.value === 'GR' ? 'EL' : selection.value});
		} else {
			this.setState({vat_prefix: null});
		}
		this.props.handleChangeCountry(selection);
	}

	handleClientSave(property) {
		this.props.handleClientSave(property);
	}

	checkEmailValidity(isValid) {
		this.setState({
			showEmailValidationError: !isValid,
			emailValidationErrorMessage: !isValid ? this.props.intl.formatMessage({id: 'settings_team.invalid-email'}) : this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'}),
		});
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="trial-end-card large">
				<div className="details" data-cy={'company-details'}>
					<div className="content">
						<div className="section">
							<h3 className="no-top-margin">{formatMessage({id: 'company_details.header'})}</h3>

							<label htmlFor="company_name">
								<span className="required">{formatMessage({id: 'company_details.company_name_label'}).toUpperCase()}</span>
								<InputField
									type="text"
									placeholder={formatMessage({id: 'company_details.company_name_placeholder'})}
									id="company_name"
									hideLabel={true}
									size="70"
									value={this.props.name}
									onChange={this.handleFieldChange.bind(this, 'name')}
									onBlur={this.handleClientSave.bind(this, 'name')}
									data-cy={'company-name-input'}
								/>
							</label>
							<label htmlFor="company_street">
								<span className="required">{formatMessage({id: 'company_details.street_label'}).toUpperCase()}</span>
								<InputField
									type="text"
									placeholder={formatMessage({id: 'company_details.street_placeholder'})}
									id="company_street"
									hideLabel={true}
									size="70"
									value={this.props.street}
									onChange={this.handleFieldChange.bind(this, 'street')}
									onBlur={this.handleClientSave.bind(this, 'street')}
									data-cy={'company-street-input'}
								/>
							</label>
							<div className="zip-city-wrapper">
								<label htmlFor="company_zip">
									<span className="required">{formatMessage({id: 'company_details.zip_label'}).toUpperCase()}</span>
									<InputField
										type="text"
										placeholder={formatMessage({id: 'company_details.zip_placeholder'})}
										id="company_zip"
										hideLabel={true}
										size="35"
										value={this.props.zip}
										onChange={this.handleFieldChange.bind(this, 'zip')}
										onBlur={this.handleClientSave.bind(this, 'zip')}
										data-cy={'company-zip-input'}
									/>
								</label>
								<label htmlFor="company_city">
									<span className="required">{formatMessage({id: 'company_details.city_label'}).toUpperCase()}</span>
									<InputField
										type="text"
										placeholder={formatMessage({id: 'company_details.city_placeholder'})}
										id="company_city"
										hideLabel={true}
										size="35"
										value={this.props.city}
										onChange={this.handleFieldChange.bind(this, 'city')}
										onBlur={this.handleClientSave.bind(this, 'city')}
										data-cy={'company-city-input'}
									/>
								</label>
							</div>
							{this.props.zip_error ? <div className="zip-error">{formatMessage({id: 'signup.zip-is-invalid'})}</div> : null}
							<div className="country-vat-wrapper">
								<label htmlFor="company_country">
									<span className="required">{formatMessage({id: 'company_details.country_label'}).toUpperCase()}</span>
									<div className="select-wrapper" data-cy={'company-country-input'}>
										<DropdownV2
											stylingTheme={'white'}
											hideLabel={true}
											value={this.props.country}
											placeholder={formatMessage({
												id: 'company_details.country_placeholder',
											})}
											onChange={this.handleChangeCountry.bind(this)}
											options={isoCountries}
											customHeight={40}
											maxHeight={300}
											dataCy={'company-country-input-type'}
											listDataCy="country"
										/>
									</div>
								</label>
								<label htmlFor="company_vat">
									<span className={this.state.vat_prefix ? 'required' : ''}>{formatMessage({id: 'company_details.vat_label'}).toUpperCase()}</span>
									<div className="vat-wrapper" style={{display: 'inline-block', position: 'relative'}}>
										<InputField
											style={this.state.vat_prefix ? {paddingLeft: '40px'} : {}}
											type="text"
											autoComplete={'nope'}
											placeholder={formatMessage({id: 'company_details.vat_placeholder'})}
											id="company_vat"
											hideLabel={true}
											size="35"
											value={this.props.vatId}
											onChange={this.handleFieldChange.bind(this, 'vatId')}
											onBlur={this.handleClientSave.bind(this, 'vatId')}
											data-cy={'company-vat-input'}
										/>
										{this.state.vat_prefix ? <span className="vat-country-code">{this.state.vat_prefix}</span> : null}
									</div>
									{this.props.vat_error ? <div className="vat-error">{formatMessage({id: 'signup.vat_is_invalid'})}</div> : null}
								</label>
							</div>
						</div>
						<div className="section">
							<h3>{formatMessage({id: 'company_details.contact_header'})}</h3>
							<label htmlFor="company_contact_name">
								<span className="required">{formatMessage({id: 'company_details.contact_name_label'}).toUpperCase()}</span>
								<InputField
									type="text"
									placeholder={formatMessage({id: 'company_details.contact_name_placeholder'})}
									id="company_contact_name"
									hideLabel={true}
									size="70"
									value={this.props.contactName}
									onChange={this.handleFieldChange.bind(this, 'contactName')}
									onBlur={this.handleClientSave.bind(this, 'contactName')}
									data-cy={'contact-name-input'}
								/>
							</label>
							<label htmlFor="company_contact_email">
								<span className="required">{formatMessage({id: 'company_details.contact_email_label'}).toUpperCase()}</span>
								<InputField
									type="text"
									placeholder={formatMessage({id: 'company_details.contact_email_placeholder'})}
									id="company_contact_email"
									hideLabel={true}
									size="70"
									value={this.props.contactEmail}
									onChange={this.handleFieldChange.bind(this, 'contactEmail')}
									onBlur={this.handleClientSave.bind(this, 'contactEmail')}
									data-cy={'contact-email-input'}
								/>
							</label>
							<label htmlFor="company_contact_phone">
								<span className="required">{formatMessage({id: 'company_details.contact_phone_label'}).toUpperCase()}</span>
								<InputField
									type="text"
									placeholder={formatMessage({id: 'company_details.contact_phone_placeholder'})}
									id="company_contact_phone"
									hideLabel={true}
									size="70"
									value={this.props.contactPhone}
									onChange={this.handleFieldChange.bind(this, 'contactPhone')}
									onBlur={this.handleClientSave.bind(this, 'contactPhone')}
									data-cy={'contact-phone-input'}
								/>
							</label>
						</div>
					</div>
					<div className="section">
						<h3>{formatMessage({id: 'settings_subscription.payment-details'})}</h3>
						<label htmlFor="invoice_email">
							<span className="required">{formatMessage({id: 'settings_subscription.invoice-email'}).toUpperCase()}</span>
							<InputField
								id="invoice_email"
								value={this.props.invoiceEmail}
								onChange={this.handleFieldChange.bind(this, 'invoiceEmail')}
								type="email"
								placeholder={formatMessage({id: 'settings_subscription.invoice-email'})}
								hideLabel={true}
								checkEmailValidity={this.checkEmailValidity.bind(this)}
								invalidInput={this.state.showEmailValidationError}
								errorMessage={this.state.emailValidationErrorMessage}
								shouldFocus={this.state.showEmailValidationError}
								cy={'invoice-email-input'}
							/>
						</label>
					</div>
				</div>
			</div>
		);
	}
}

DetailsSection.propTypes = {};

export default injectIntl(DetailsSection);
